// extracted by mini-css-extract-plugin
export var select = "_r6-0";